import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from '../Icon/Icon';
import ArrowLeft from '../../assets/svg/ArrowLeft.svg';
import ArrowRight from '../../assets/svg/ArrowRight.svg';
import * as styles from './Slider.css';
import { dt } from '../../helpers/Utils/GetTailwindToken';
import { isDesktopWidth, isMobileWidth } from '../../helpers/Utils/mediaQuery';

const cx = classNames.bind(styles);

export class Slider extends Component {
    static defaultProps = {
        wrapperClass: '',
        contentWrapperClass: '',
        customLeftButtonSliderClass: '',
        customRightButtonSliderClass: '',
        imageHeight: 0,
        isCategoryPromo: false,
    };

    static propTypes = {
        wrapperClass: PropTypes.string,
        children: PropTypes.element.isRequired,
        contentWrapperClass: PropTypes.string,
        customLeftButtonSliderClass: PropTypes.string,
        customRightButtonSliderClass: PropTypes.string,
        imageHeight: PropTypes.number,
        isCategoryPromo: PropTypes.bool,
    };

    state = {
        disableLeftArrow: true,
        disableRightArrow: false,
        animateWrapperClass: {},
    };

    componentDidMount() {
        if (isMobileWidth()) return;
        this.disableArrowCheck();
        window.addEventListener('scroll', this.onScrollTransition.bind(this));
        window.addEventListener('resize', this.onResizeCallback.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const { children = {} } = this.props;
        const { children: nextPropsChildren = {} } = nextProps || {};
        if (isDesktopWidth() && nextPropsChildren !== children) {
            this.scrollPosition = 0;
            this.disableArrowCheck();
        }
    }

    componentWillUnmount() {
        if (isMobileWidth()) return;
        window.removeEventListener('scroll', this.onScrollTransition.bind(this));
        window.removeEventListener('resize', this.onResizeCallback.bind(this));
    }

    onResizeCallback = () => {
        this.disableArrowCheck();
    };

    onScrollTransition = () => {
        // pageYOffset is compatable with all browsers
        const currentScrollTop = window.pageYOffset;
        const { disableLeftArrow, disableRightArrow } = this.state;
        const addButtonAnimationStyle = dt(['translate-x-0', 'opacity-100']);
        const removeButtonAnimationStyle = dt(['opacity-0']);
        const animateRightStyle = dt([
            'translate-x-0',
            'transition-all',
            'duration-200',
            'ease-ease',
        ]);
        const animateLeftStyle = dt([
            '-translate-x-5',
            'transition-all',
            'duration-200',
            'ease-ease',
        ]);

        if (this.isComponentVisible() && !(disableLeftArrow && disableRightArrow)) {
            const wrapperTransitionClass =
                this.previousScrollTop > currentScrollTop
                    ? cx('animateRight', animateRightStyle)
                    : cx('animateLeft', animateLeftStyle);
            this.setState({
                animateWrapperClass: wrapperTransitionClass,
                animateButtonsClass: addButtonAnimationStyle,
            });
        } else {
            this.setState({ animateButtonsClass: removeButtonAnimationStyle });
        }
        this.previousScrollTop = currentScrollTop;
    };

    getDimensions() {
        if (!this.wrapperRef || !this.listParentRef) return {};
        const { width: wrapperWidth } = this.wrapperRef.getBoundingClientRect() || {};
        const { scrollWidth: parentWidth, childElementCount } = this.listParentRef;
        return {
            wrapperWidth,
            parentWidth,
            childElementCount,
        };
    }

    getListParentRef = (ref) => {
        this.listParentRef = ref;
    };

    scrollPosition = 0;

    listParentRef = null;

    isComponentVisible = () => {
        if (!this.listParentRef) return false;
        const { top = 0, height = 0 } = this.listParentRef.getBoundingClientRect() || {};
        const { innerHeight } = window;
        const { documentElement: { clientHeight } = {} } = document;
        const windowInnerHeight = innerHeight || clientHeight || 0;
        const heightPoint = height / 4;
        const showContent =
            top + height - heightPoint <= windowInnerHeight && top + heightPoint >= 0;
        return showContent;
    };

    scrollCartridge = (scrollToRight) => {
        const { wrapperWidth = 0, parentWidth = 0 } = this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        if (scrollToRight) {
            const newScrollPosition = this.scrollPosition - wrapperWidth;
            this.scrollPosition =
                newScrollPosition >= maxMoveToRight ? newScrollPosition : maxMoveToRight;
        } else {
            const newScrollPosition = this.scrollPosition + wrapperWidth;
            this.scrollPosition =
                newScrollPosition <= maxMoveToLeft ? newScrollPosition : maxMoveToLeft;
        }
        if (this.listParentRef)
            this.listParentRef.style.transform = `translate(${this.scrollPosition}px)`;
        this.disableArrowCheck();
    };

    disableArrowCheck = () => {
        const { wrapperWidth = 0, parentWidth = 0, childElementCount = 0 } =
            this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        const rightArrowCheck = this.scrollPosition <= maxMoveToRight || childElementCount <= 4;
        const leftArrowCheck = this.scrollPosition >= maxMoveToLeft || childElementCount <= 4;
        this.setState({
            animateWrapperClass: (rightArrowCheck || leftArrowCheck) && '',
            disableRightArrow: rightArrowCheck,
            disableLeftArrow: leftArrowCheck,
        });
    };

    renderNavigationButtons = () => {
        const { disableLeftArrow, disableRightArrow, animateButtonsClass } = this.state;
        const leftArrowClass = cx({ iconClass: true, disabledArrow: disableLeftArrow });
        const rightArrowClass = cx({ iconClass: true, disabledArrow: disableRightArrow });
        if (disableLeftArrow && disableRightArrow) return null;
        const {
            customLeftButtonSliderClass,
            customRightButtonSliderClass,
            imageHeight,
        } = this.props;
        const btnPositionStyle = imageHeight
            ? { margin: '0px', top: `${imageHeight / 2 - 20}px` }
            : null;
        const leftRightArrow = dt([
            'absolute',
            'w-[45px]',
            'h-[43.8px]',
            'rounded-half',
            'bg-white',
            'bg-opacity-90',
            'border-0',
            'z-[4]',
            'm-auto',
            'cursor-pointer',
            'bottom-0',
            'top-0',
            'shadow-elevation1',
            'transition-all',
            'duration-100',
            'ease-in',
            'disabled:hidden',
        ]);
        return (
            <>
                <button
                    className={cx(
                        'arrow',
                        'leftArrow',
                        leftRightArrow,
                        customLeftButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableLeftArrow}
                    onClick={() => this.scrollCartridge(false)}
                    style={btnPositionStyle}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={leftArrowClass}
                    >
                        <ArrowLeft />
                    </Icon>
                </button>
                <button
                    className={cx(
                        'arrow',
                        'rightArrow',
                        leftRightArrow,
                        customRightButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableRightArrow}
                    onClick={() => this.scrollCartridge(true)}
                    style={btnPositionStyle}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={rightArrowClass}
                    >
                        <ArrowRight />
                    </Icon>
                </button>
            </>
        );
    };

    render() {
        const { wrapperClass, contentWrapperClass, children, isCategoryPromo } = this.props;
        const { animateWrapperClass } = this.state;
        const extraPropsToChildren = isDesktopWidth()
            ? {
                  listParentRef: this.getListParentRef,
              }
            : {};
        const wrapperClassOndeviceType = !isDesktopWidth() && 'mobileSlider';
        const childrenElement = React.cloneElement(children, extraPropsToChildren);
        const sliderWrapperStyle = dt(['relative', 'w-full']);
        return (
            <div
                className={cx(
                    'sliderWrapper',
                    sliderWrapperStyle,
                    wrapperClass,
                    wrapperClassOndeviceType
                )}
            >
                <div
                    className={cx('contentWrapper', contentWrapperClass, animateWrapperClass)}
                    ref={(el) => {
                        this.wrapperRef = el;
                    }}
                >
                    {childrenElement}
                </div>
                {this.listParentRef &&
                    isDesktopWidth() &&
                    !isCategoryPromo &&
                    this.renderNavigationButtons()}
            </div>
        );
    }
}

export default Slider;
